import { render, staticRenderFns } from "./CoursesCard.vue?vue&type=template&id=4c6eb602"
import script from "./CoursesCard.vue?vue&type=script&lang=js"
export * from "./CoursesCard.vue?vue&type=script&lang=js"
import style0 from "./CoursesCard.vue?vue&type=style&index=0&id=4c6eb602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports